import * as yup from 'yup';

export const SignInFormValidationSchema = yup.object().shape({
	email: yup
		.string()
		.trim()
		.email('Please enter a valid email address')
		.required('Email is required'),
	password: yup
		.string()
		.trim()
		.required('Password is required')
		.min(8, 'Password must be at least 8 characters'),
});
